// Pinned corner pill that surfaces which Supabase project the running
// instance is connected to. Pulls VITE_SUPABASE_URL out of import.meta.env
// (resolved by Vite at dev/build time, never lies about what the running
// code is talking to) and matches it against the known project refs.
// Production builds keep the badge visible too — when an installed copy
// somehow ends up on staging keys, the operator should see it.

import { extractProjectRef, PROD_REF, STAGING_REF } from '../utils/env';

const KNOWN_REFS: Record<string, { label: string; tone: 'staging' | 'prod' | 'other' }> = {
  [STAGING_REF]: { label: 'STAGING', tone: 'staging' },
  [PROD_REF]:    { label: 'PROD',    tone: 'prod'    },
};

export default function SupabaseEnvBadge() {
  const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
  const ref = extractProjectRef(url);
  if (!ref) return null;

  const known = KNOWN_REFS[ref];
  // Suppress the badge on prod when the build is meant for prod kiosks.
  // Always show on staging or unknown refs.
  if (known?.tone === 'prod' && import.meta.env.PROD) return null;

  const label = known?.label ?? ref.slice(0, 8).toUpperCase();
  const tone = known?.tone ?? 'other';

  return (
    <div
      className={`supabase-env-badge supabase-env-badge--${tone}`}
      title={`Connected to ${url}`}
    >
      <span className="supabase-env-badge-dot" />
      {label}
    </div>
  );
}
